(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGarmentCare(context) {
    const roots = context.matches && context.matches('[data-garment-care]')
      ? [context]
      : context.querySelectorAll('[data-garment-care]');

    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.garmentCareReady === 'true') return;
      root.dataset.garmentCareReady = 'true';
      root.classList.add('is-ready');

      const revealItems = [...root.querySelectorAll('[data-garment-reveal], [data-garment-reveal-item]')];

      if (reduceMotion) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      if ('IntersectionObserver' in window) {
        const getRevealGroup = (item) => item.matches('[data-garment-reveal]')
          ? [item, ...item.querySelectorAll('[data-garment-reveal-item]')]
          : [item];

        const showGroup = (group) => {
          group.forEach((item, index) => {
            const revealDelay = Math.min(index * 90, 420);
            item.style.setProperty('--garment-reveal-delay', `${revealDelay}ms`);
            item.classList.add('is-visible');
          });
        };

        const resetGroup = (group) => {
          group.forEach((item) => {
            item.classList.remove('is-visible');
          });
        };

        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const group = getRevealGroup(entry.target);

              if (entry.isIntersecting) {
                showGroup(group);
                return;
              }

              if (entry.boundingClientRect.top > window.innerHeight * 0.92) {
                resetGroup(group);
              }
            });
          },
          { rootMargin: '0px 0px -14% 0px', threshold: 0.14 }
        );

        root.querySelectorAll('[data-garment-reveal]').forEach((item) => revealObserver.observe(item));
        root.querySelectorAll('[data-garment-reveal-item]').forEach((item) => {
          if (!item.closest('[data-garment-reveal]')) revealObserver.observe(item);
        });
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGarmentCare(document));
  } else {
    initGarmentCare(document);
  }

  document.addEventListener('shopify:section:load', (event) => initGarmentCare(event.target));
})();
